import PartnerContactInformationFlatScreen from './screens/partnercontactinformationflat-screen';
import { RouteDefinition } from '../../core/route';

export const partnercontactinformationflatRoutes: RouteDefinition[] = [
  {
    id: 'PartnerContactInformationFlatList',
    title: 'Partner Contact Information',
    path: 'partner-contact-information',
    element: <PartnerContactInformationFlatScreen />,
    showInNavigation: true,
  },
];
